'use client';

import { faCartShopping } from '@fortawesome/pro-light-svg-icons';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { HeaderCartBadge } from './header-cart-badge.component';

import { CartModal } from '@/app/(main)/_components/cart/cart-modal.component';
import { IconButton } from '@/components/ui/icon-button/icon-button.component';
import { useCart } from '@/hooks/use-cart.hook';
import { authStore } from '@/store/auth.store';
import { loadCart, setCartOpen } from '@/store/cart/cart.store';
import { getCartOrigin } from '@/utils/cart/get-cart-origin.util';

function getCartLabel(itemCount: number): string {
  if (itemCount <= 0) {
    return 'Carrinho';
  }

  return `Carrinho, ${itemCount} ${itemCount === 1 ? 'item' : 'itens'}`;
}

export function HeaderCartButton() {
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const { itemCount } = useCart();
  const pathname = usePathname();

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    void loadCart();
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <>
      <div className="flex items-start">
        <IconButton
          icon={faCartShopping}
          label={getCartLabel(itemCount)}
          data-testid={DataTestIdEnum.CART_HEADER_BUTTON}
          onClick={() => setCartOpen(true, getCartOrigin(pathname))}
        />

        <HeaderCartBadge itemCount={itemCount} />
      </div>

      <CartModal />
    </>
  );
}
